module.exports = __webpack_public_path__ + "static/img/afm-logo.4292104.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/afm-logo.png
// module id = 4f2A
// module chunks = 1